var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"upload-file",class:{'selected-file':_vm.selected},attrs:{"attached":"true","contenteditable":"false","draggable":"true"},on:{"mousedown":_vm.fileSelect,"click":function($event){$event.preventDefault();}}},[_vm._v(_vm._s(_vm.linkText))])
}
var staticRenderFns = []

export { render, staticRenderFns }